import types from './types.js';

let { GET_VIP_DETAIL } = types;

export default {
  [GET_VIP_DETAIL]( state, data ) {
    state.bottomList = data.bottom;
    state.rightsList = [].concat(data.centerList);
    state.conditionList = [].concat(data.conditionList);
    state.deadline = data.deadline;
    state.isup = data.isup;
    state.privBuyList = [].concat(data.privBuyList);
    state.privLeft = data.privLeft;
    state.privList =[].concat(data.privList);
    state.privUpV2List = [].concat(data.privUpV2List);
    state.viplevel = data.viplevel;

  }
}


// WEBPACK FOOTER //
// ./src/projects/vipCard/pages/home/store/mutations.js